/** Safely gets a value from localStorage at the provided key. */
export const localStorageGet = <T = any>(key: string): T | undefined => {
  try {
    const item = window.localStorage.getItem(key);

    return item !== null ? JSON.parse(item) : undefined;
  } catch {
    return undefined;
  }
};

/** Safely sets a value in the localStorage at the provided key. */
export const localStorageSet = <T>(key: string, value?: T) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(error); // eslint-disable-line no-console
  }
};
